import { render, staticRenderFns } from "./ThePartnerList.vue?vue&type=template&id=3c1c55a3&scoped=true"
import script from "./ThePartnerList.vue?vue&type=script&lang=ts"
export * from "./ThePartnerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c55a3",
  null
  
)

export default component.exports